import SectionTitle from "@/components/feature/SectionTitle";
import { principles } from "@/mocks/site";

export default function PrinciplesSection() {
  return (
    <section className="w-full bg-background-100 px-4 py-14 md:px-8 md:py-20">
      <SectionTitle
        align="center"
        eyebrow="内容原则"
        title="吃瓜可以轻松，但不该越界"
        desc="我们给自己定了四条规矩，让速览既好读，也不伤害任何人。"
      />

      <div className="mt-10 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4">
        {principles.map((item, index) => (
          <article
            key={item.title}
            className="flex flex-col rounded-card border border-background-200 bg-background-50 p-5"
          >
            <span
              className={`flex h-11 w-11 items-center justify-center rounded-md text-lg ${
                index % 2 === 0 ? "bg-primary-100 text-primary-700" : "bg-accent-100 text-accent-800"
              }`}
            >
              <i className={item.icon} />
            </span>
            <h3 className="mt-4 font-heading text-base font-semibold text-foreground-950">{item.title}</h3>
            <p className="mt-2 text-sm leading-relaxed text-foreground-600">{item.desc}</p>
          </article>
        ))}
      </div>
    </section>
  );
}